<script setup lang="ts">
import TgIcon from '@features/apps/assets/social/telegram.svg'
import VkIcon from '@features/apps/assets/social/vk.svg'
import { APPS_SOCIAL_LINKS } from '@features/apps/constants'

const SOCIAL_ICONS = {
  vk: VkIcon,
  telegram: TgIcon,
} as const

const socialNetworksLinks = APPS_SOCIAL_LINKS.map((link) => ({
  ...link,
  image: SOCIAL_ICONS[link.key],
}))
</script>

<template>
  <div class="social-networks">
    <span class="social-networks__text">Делись с друзьями:</span>

    <nuxt-link
      v-for="link in socialNetworksLinks"
      :key="link.key"
      :href="link.href"
      target="_blank"
      class="social-networks__link"
    >
      <nuxt-img
        class="social-networks__image"
        :src="link.image"
        :alt="link.key"
      />
    </nuxt-link>
  </div>
</template>

<style scoped lang="scss">
.social-networks {
  display: flex;
  gap: 16px;
  align-items: center;

  &__text {
    font-size: 14px;
    font-weight: 800;
  }

  &__link {
    width: 46px;
    height: 46px;
    color: $background-dark;
  }

  &__image {
    width: 100%;
    height: 100%;
  }

  @include media($bp-tablet) {
    &__link {
      width: 56px;
      height: 56px;
    }
  }

  @include media($bp-desktop-mini) {
    &__text {
      font-size: 16px;
    }
  }
}
</style>
